import type { MutationTree } from 'vuex'
import type { Emulator } from '@/types/emulator'
import type { DeveloperPanelState } from './types'
import { DEVELOPER_PANEL_MUTATIONS } from './types'

interface IDeveloperPanelMutations extends MutationTree<DeveloperPanelState> {
  [DEVELOPER_PANEL_MUTATIONS.ADD_EMULATOR](
    state: DeveloperPanelState,
    data: Emulator | Emulator[]
  ): void
  [DEVELOPER_PANEL_MUTATIONS.SET_EMULATORS](state: DeveloperPanelState, data: Emulator[]): void
}

const mutations: IDeveloperPanelMutations = {
  [DEVELOPER_PANEL_MUTATIONS.ADD_EMULATOR](state, data) {
    state.emulators = state.emulators.concat(data)
  },
  [DEVELOPER_PANEL_MUTATIONS.SET_EMULATORS](state, data) {
    state.emulators = data
  },
}

export default mutations
